import {
  Pipe,
  PipeTransform,
} from '@angular/core';
import { LocaleService } from '@dspace/core/locale/locale.service';
import { filesize } from 'filesize';
import { take } from 'rxjs/operators';

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 */

@Pipe({
  name: 'dsFileSize',
})
export class FileSizePipe implements PipeTransform {

  private currentLocale: string;

  constructor(private localeService: LocaleService) {
    this.localeService.getCurrentLanguageCode().pipe(take(1)).subscribe(locale => {
      this.currentLocale = locale;
    });
  }

  transform(bytes: number = 0, precision: number = 2): string {
    return filesize(bytes, {
      standard: 'jedec',
      round: precision,
      locale: this.currentLocale,
    });
  }
}
